import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
    attribute : { label : ""},
    attributes:[],
}

const attribute = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default attribute;